import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Card } from "react-bootstrap";
import { EnvelopeFill, TelephoneFill } from "react-bootstrap-icons";

export default function ContatoPage() {
    return (
        <section id="contato" >
            <Container>
                <h1 className="text-center mb-4 fw-bold">Fale Conosco</h1>
                <p className="text-center text-muted mb-5">
                    Entre em contato com nossa equipe para tirar dúvidas, obter suporte ou mais informações sobre o MDF-e.
                </p>

                <Row className="justify-content-center g-4">

                    <Col md={4} sm={6}>
                        <Card className="text-center shadow-sm border-0 h-100">
                            <Card.Body>
                                <div className='d-flex justify-content-evenly align-items-center'>
                                    <EnvelopeFill size={50} className="text-primary " />
                                    <div>
                                        <p className="fw-bold h5">E-mail</p>
                                        <p className="text-muted">contato@plugsystem.natal.br</p>

                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} sm={6}>
                        <Card className="text-center shadow-sm border-0 h-100">
                            <Card.Body>
                                <div className='d-flex justify-content-evenly align-items-center'>
                                    <div className=''>
                                        <TelephoneFill size={40} className="text-success mb-3" />
                                    </div>
                                    <div className='auto-ms'>
                                        <p className="fw-bold h5">Celular / WhatsApp</p>
                                        <p className="text-muted">(84) 98836-7305</p>

                                    </div>
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </section>
    );
}
